<template>
  <div class="home d-flex align-center">
    <v-progress-circular indeterminate color="primary"> </v-progress-circular>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",

  mounted() {
    this.$router.push({ path: "/signin" });
  },
});
</script>
